import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { useAuth } from "../context/AuthContext";
import { useLang } from "../context/LanguageContext";
import LanguageSwitcher from "../components/LanguageSwitcher";
import { toast } from "sonner";

export default function Register() {
  const { register } = useAuth();
  const { t } = useLang();
  const navigate = useNavigate();
  const [form, setForm] = useState({ business_name: "", email: "", password: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const res = await register(form.email, form.password, form.business_name);
    setLoading(false);
    if (res.ok) {
      toast.success(t("toast_welcome"));
      navigate("/dashboard");
    } else {
      toast.error(res.error);
    }
  };

  const update = (k, v) => setForm((s) => ({ ...s, [k]: v }));

  return (
    <div className="min-h-screen bg-[#FFFDF9] bg-grain flex items-center justify-center px-6 py-12 relative">
      <div className="absolute top-4 right-4 z-30 md:right-6 md:top-6">
        <LanguageSwitcher variant="glass" />
      </div>
      <form onSubmit={submit} className="w-full max-w-md" data-testid="register-form">
        <Link to="/" className="inline-flex items-center gap-2 mb-10" data-testid="brand-link">
          <div className="w-9 h-9 rounded-lg bg-[#0A2540] grid place-items-center text-white font-bold font-display">R</div>
          <span className="font-display font-semibold text-lg">ReviewFlow</span>
        </Link>
        <h1 className="font-display text-3xl font-bold text-[#0A2540]">{t("auth_register_title")}</h1>
        <p className="mt-2 text-slate-600">{t("auth_register_sub")}</p>

        <div className="mt-8 space-y-5">
          <div>
            <Label className="text-sm">{t("field_business")}</Label>
            <Input
              required
              value={form.business_name}
              onChange={(e) => update("business_name", e.target.value)}
              data-testid="register-business-input"
              className="mt-1.5 h-11"
              placeholder={t("field_business_ph")}
            />
          </div>
          <div>
            <Label className="text-sm">{t("field_email")}</Label>
            <Input
              type="email"
              required
              value={form.email}
              onChange={(e) => update("email", e.target.value)}
              data-testid="register-email-input"
              className="mt-1.5 h-11"
              placeholder="you@business.com"
            />
          </div>
          <div>
            <Label className="text-sm">{t("field_password_hint")}</Label>
            <Input
              type="password"
              required
              minLength={6}
              value={form.password}
              onChange={(e) => update("password", e.target.value)}
              data-testid="register-password-input"
              className="mt-1.5 h-11"
            />
          </div>

          <Button
            type="submit"
            disabled={loading}
            data-testid="register-submit-btn"
            className="w-full h-11 rounded-md bg-[#E57C4F] hover:bg-[#E57C4F]/90 text-white text-base font-semibold"
          >
            {loading ? t("register_submitting") : t("register_submit")}
          </Button>
        </div>

        <p className="mt-8 text-sm text-slate-600">
          {t("have_account")}{" "}
          <Link to="/login" className="font-semibold text-[#0A2540] hover:underline" data-testid="link-to-login">
            {t("login_link")}
          </Link>
        </p>
      </form>
    </div>
  );
}
